import React, { Component } from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from '../components/confirmDialog';
import * as webViewerLicensesActions from '../store/webViewerLicensesSlice';
import { webViewerLicensesSelectors } from '../store/webViewerLicensesSlice';
import { showModalMessage } from '../store/modalsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Remove: 0,
  Restore: 1
};

class RemoveRestoreWebViewerLicensesConfirmDialog extends Component {
  static get Mode() {
    return Mode;
  }

  constructor(props) {
    super(props);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm() {
    let processor = null;

    if (this.props.mode === Mode.Remove)
      processor = this.props.removeWebViewerLicenses;
    else if (this.props.mode === Mode.Restore)
      processor = this.props.restoreWebViewerLicenses;

    if (processor !== null) {
      processor({ webViewerLicenseIds: this.props.licenseIds })
        .then(unwrapResult)
        .catch(() => {
          this.props.showModalMessage("Error", this.props.error.toString());
        });
    }
    this.props.onClose();
  }

  render() {
    let qoperation = null;
    let toperation = null;
    if (this.props.mode === Mode.Remove) {
      qoperation = "remove";
      toperation = "removing";
    } else if (this.props.mode === Mode.Restore) {
      qoperation = "restore";
      toperation = "restoring";
    }
    else
      return null;

    let c = this.props.licenseIds.length;
    let question = <React.Fragment>
      {`Are you sure want to ${qoperation} `}
      {c > 1 ? <strong>{c} </strong> : ""}
      {`selected web viewer license${c > 1 ? "s" : ""}?`}
      </React.Fragment>;
    return (
      <ConfirmDialog
        show={this.props.show}
        onClose={this.props.onClose}
        title={`Web viewer licenses ${toperation}`}
        question={question}
        onConfirm={this.onConfirm}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  error: webViewerLicensesSelectors.state(state).removingRestoringError,
});

const actionCreators = {
  removeWebViewerLicenses: webViewerLicensesActions.remove,
  restoreWebViewerLicenses: webViewerLicensesActions.restore,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
}

export default connect(mapStateToProps, actionCreators)(RemoveRestoreWebViewerLicensesConfirmDialog);


// WEBPACK FOOTER //
// ./src/containers/removeRestoreWebViewerLicensesConfirmDialog.js